"use client";

import Link from "next/link";
import { useSession } from "next-auth/react";
import { redirect } from "next/navigation";
import { useState } from "react";
import { signIn } from "next-auth/react";

export default function Login() {
  const { data: session, status } = useSession();
  const isLoggedIn = status === "authenticated";

  if(isLoggedIn) {
    redirect("/")
  }

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function handleLogin(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    setError("");
    setMessage("");

    // Call NextAuth signIn with credentials and handle response
    const res = await signIn("credentials", {
      redirect: true,
      email,
      password,
    });

    if (res?.error) {
      setError(res.error);
    } else {
      setMessage(`Welcome back, ${email}!`);
      // Optionally redirect
      /*setTimeout(() => {
        window.location.href = "/account/dashboard";
      }, 500);*/
    }
  }

  return (
    <section className="py-10">
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-[rgba(249,115,22,0.2)] border-2 border-[rgba(249,115,22,0.2)] rounded-xl shadow-lg p-8">
          <h2 className="text-3xl font-bold text-white mb-6 text-center">Login</h2>

          {error && (
            <p className="border-2 border-red-600 bg-red-200 rounded-lg text-red-700 p-2 my-3">
              {error}
            </p>
          )}
          {message && (
            <p className="border-2 border-green-600 bg-green-200 rounded-lg text-green-700 p-2 my-3">
              {message}
            </p>
          )}

          <form className="space-y-5" onSubmit={handleLogin}>
            <div>
              <label className="block mb-1 text-gray-300 text-sm font-extrabold">Email</label>
              <input
                type="email"
                className="w-full px-4 py-2 rounded-lg bg-transparent border border-gray-600 text-white focus:outline-none focus:border-orange-400"
                value={email}
                placeholder="john@example.com"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div>
              <label className="block mb-1 text-gray-300 text-sm font-extrabold">Password</label>
              <input
                type="password"
                className="w-full px-4 py-2 rounded-lg bg-transparent border border-gray-600 text-white focus:outline-none focus:border-orange-400"
                value={password}
                placeholder="************"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="flex items-center justify-between text-sm text-gray-400">
              <Link href="/auth/forgot-password" className="hover:underline hover:text-orange-400">
                Forgot password?
              </Link>
            </div>

            <button
              type="submit"
              className="w-full py-2 px-4 rounded-lg text-white font-semibold border-2 border-orange-700 bg-orange-400 hover:bg-orange-600 transition-all duration-200 ease-linear"
            >
              Login
            </button>
          </form>

          <p className="text-sm text-gray-400 mt-6 text-center">
            Don’t have an account?{" "}
            <Link href="../auth/register" className="text-orange-400 hover:underline">
              Register
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}
